import { createQueryKeys, createResourceHooks } from '@codes/base-api';

import { accessKeysApi } from '../api';
import type { SecretCredentialBody, SecretCredentialView } from '../types';

/**
 * Query keys for Secret Credentials (Access Keys)
 */
export const accessKeyQueryKeys = createQueryKeys('access-keys');

/**
 * Secret Credentials hooks
 */
const hooks = createResourceHooks<SecretCredentialView, SecretCredentialBody>(accessKeysApi, accessKeyQueryKeys);

export const useAccessKeyList = hooks.useList;
export const useCreateAccessKey = hooks.useCreate;
export const useUpdateAccessKey = hooks.useUpdate;
export const useDeleteAccessKey = hooks.useDelete;
